"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CARD_SPACING_REDUCED = exports.CARD_SPACING = exports.CARD_PADDING_HORIZONTAL = void 0;
var CARD_PADDING_HORIZONTAL = 'S200';
exports.CARD_PADDING_HORIZONTAL = CARD_PADDING_HORIZONTAL;
var CARD_SPACING = 'S500';
exports.CARD_SPACING = CARD_SPACING;
var CARD_SPACING_REDUCED = 'S300';
exports.CARD_SPACING_REDUCED = CARD_SPACING_REDUCED;